import CourseGrade from './CourseGrade';

export default CourseGrade;
